import React from 'react';

export interface EmptyStateProps {
  /** Optional icon node (FeatherIcon or similar). */
  icon?: React.ReactNode;
  /** Headline — what's missing or not yet done. */
  title?: React.ReactNode;
  /** Friendly explanation, one sentence. */
  description?: React.ReactNode;
  /** Optional CTA. */
  action?: React.ReactNode;
}

/**
 * Used inside Card/Section bodies when the data is empty. Keeps the layout
 * looking intentional instead of just rendering nothing.
 */
export const EmptyState: React.FC<EmptyStateProps> = ({
  icon, title, description, action,
}) => {
  return (
    <div className="vc-empty">
      {icon && <div className="vc-empty__icon">{icon}</div>}
      {title && <div className="vc-empty__title">{title}</div>}
      {description && <div className="vc-empty__desc">{description}</div>}
      {action && <div className="vc-empty__action">{action}</div>}
    </div>
  );
};
